import React from 'react'
import './ShowData.css'

function ShowData() {
    return (
        <div className="Show">
            Show Result
            
        </div>
    )
}

export default ShowData

